<template>
  <div>
    <div v-if="finishedMount">
      <base-title :title="StringLanguage.EasyPerformance">
        <!-- <template slot="info">
          <div class="balance">
            <div class="value">Saldo: <span>R$ 355,98</span></div>
          </div>
        </template> -->

        <base-button
          @click="drawer.open = !drawer.open"
          class="m_auto filter"
          :class="isMobile ? 'reverse w-100' : 'ml_20'"
          design="two"
        >
          <p class="filter" v-if="!isMobile">
            <i class="fal fa-calendar-day"></i>
          </p>
          <p class="filter" v-else>Filtrar período</p>
        </base-button>
      </base-title>

      <div
        class="create-campaign"
        v-if="!activeCampaigns && !completedCampaigns"
      >
        <i class="fal fa-megaphone" />
        <h1>Crie sua campanha</h1>
        <p>
          Através desta ferramenta, será possível realizar os disparos das suas
          campanhas.
        </p>
        <div class="btn-create">
          <base-button
            text="Criar campanha"
            class="big w-100"
            @click="changeRoute('criar-campanha')"
          />
        </div>
      </div>

      <div v-if="activeCampaigns || completedCampaigns">
        <div v-if="filteredCampaigns.length === 0" class="tabs mb_25">
          <ul>
            <li>
              <a @click="selectedTab = 0" :class="{ active: selectedTab === 0 }"
                >Minhas campanhas</a
              >
            </li>
            <li>
              <a @click="selectedTab = 1" :class="{ active: selectedTab === 1 }"
                >Campanhas agendadas disparadas</a
              >
            </li>
          </ul>
        </div>

        <base-box>
          <div class="d-flex justify-between align-center mb_5">
            <base-label text="Buscar campanha" class="mb_0" />
            <span class="occurrences">{{ count }} ocorrências</span>
          </div>

          <base-input
            placeholder="Procure por campanha."
            class="w-100 mb_0"
            search
            v-model="search"
            @keyup="loading = true"
            @input="isTyping = true"
          />
        </base-box>

        <div v-if="loading && activeCampaigns.length > 0" class="loading">
          <base-loading />
        </div>

        <div v-if="selectedTab === 0 && !loading">
          <div class="campaigns">
            <base-add
              v-if="filteredCampaigns.length === 0"
              text="Adicionar campanha"
              :height="isMobile ? '100px' : '100%'"
              @click.native="changeRoute('criar-campanha')"
            />

            <campaign-box
              v-for="(campaign, index) in filteredCampaigns.length === 0
                ? activeCampaigns
                : filteredCampaigns"
              :key="index"
              :campaign="campaign"
            />
          </div>
        </div>

        <div v-if="selectedTab === 1 && !loading">
          <div class="campaigns">
            <completed-campaign-box
              v-for="(campaign, index) in completedCampaigns"
              :key="index"
              :campaign="campaign"
            />
          </div>
        </div>
      </div>

      <base-drawer
        title="Filtrar por"
        :open="drawer.open"
        :close="drawer.close"
      >
        <base-card>
          <base-label text="Tipo de campanha" class="mb_20" />
          <base-checkbox @click="formatterQuery('type', 'ARD')" class="mb_10"
            >Ação de recorrência de data</base-checkbox
          >
          <base-checkbox @click="formatterQuery('type', 'ARC')" class="mb_10"
            >Ação de recorrência de conversão</base-checkbox
          >
          <base-checkbox @click="formatterQuery('type', 'APA')" class="mb_10"
            >Ação pontual agendada</base-checkbox
          >
          <base-checkbox class="mb_10" @click="formatterQuery('type', 'API')"
            >Ação pontual imediata</base-checkbox
          >
        </base-card>

        <base-card>
          <base-label text="Status de campanha" class="mb_20" />
          <base-checkbox
            @click="formatterQuery('status', 'DRAFT')"
            class="mb_10"
            >Rascunho</base-checkbox
          >
          <base-checkbox
            @click="formatterQuery('status', 'ACTIVE')"
            class="mb_10"
            >Ativa</base-checkbox
          >
          <base-checkbox
            @click="formatterQuery('status', 'SCHEDULED')"
            class="mb_10"
            >Agendada</base-checkbox
          >
          <base-checkbox
            @click="formatterQuery('status', 'FINISHED')"
            class="mb_10"
            >Finalizada</base-checkbox
          >
        </base-card>

        <template slot="footer">
          <base-button @click="handleFilter" class="w-100 big"
            >Salvar</base-button
          >
        </template>
      </base-drawer>
      <infinite-loading
        v-if="activeCampaigns.length > 0"
        :identifier="1"
        spinner="wavedots"
        @infinite="infinityCampaign"
      >
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';

import InfiniteLoading from 'vue-infinite-loading';
import BaseButton from '@/components/Button';
import BaseTitle from '@/components/Title';
import BaseBox from '@/components/Box';
import BaseAdd from '@/components/Add';
import BaseLabel from '@/components/Label';
import BaseInput from '@/components/Input';
import BaseBadge from '@/components/Badge';
import BaseDrawer from '@/components/Drawer';
import BaseCard from '@/components/Card';
import BaseCheckbox from '@/components/Checkbox';
import PerformanceApi from '@/api/modules/performance';
import ModulesApi from '@/api/modules/modules';
import BaseLoading from '@/components/Loading';
import Utils from '@/utils';

import CampaignBox from '@/containers/Modules/Performance/CampaignBox';
import CompletedCampaignBox from '@/containers/Modules/Performance/CompletedCampaignBox';

import customStorage from '@/plugins/customStorage';

export default {
  data() {
    return {
      finishedMount: true,
      activeCampaigns: [],
      filteredCampaigns: [],
      contentLoading: true,
      loading: true,
      search: '',
      queryType: [],
      queryStatus: [],
      offset: 1,
      selectedTab: 0,
      isTyping: false,
      count: 0,
      drawer: {
        open: false,
        close: false,
      },
      query: [],
      type: [],
      completedCampaigns: [],
    };
  },
  components: {
    BaseButton,
    BaseTitle,
    BaseBox,
    BaseAdd,
    BaseLabel,
    BaseInput,
    BaseBadge,
    BaseDrawer,
    BaseCard,
    BaseCheckbox,
    InfiniteLoading,
    BaseLoading,
    CampaignBox,
    CompletedCampaignBox,
  },
  async beforeCreate() {
    this.finishedMount = false;
    const performance = await ModulesApi.getModuleEnvironment();
    if (performance.getData([]).length === 0) {
      this.$router.push({ name: 'pedidos' });
    }

    this.finishedMount = true;
  },

  async created() {
    const campaigns = await this.getCampaigns({
      status: this.getStatusBySelectedTab(),
    });

    this.offset++;
    this.activeCampaigns = campaigns;
    this.loading = false;
  },
  methods: {
    nullishCoalescing(startPoint, jsonPath, defaultValue = null) {
      let props = jsonPath.split('.');
      let mainProp = startPoint;
      for(const prop of props) {
          mainProp = mainProp[prop];
          if(!mainProp) {
              return defaultValue;
          }
      }
      return mainProp
    },
    async formatterQuery(type, data) {
      if (type === 'type' && !this.queryType.includes(data)) {
        this.queryType.push(data);
      } else if (this.queryType.includes(data)) {
        this.queryType.splice(this.queryType.indexOf(data), 1);
      }

      if (type === 'status' && !this.queryStatus.includes(data)) {
        this.queryStatus.push(data);
      } else if (this.queryStatus.includes(data)) {
        this.queryStatus.splice(this.queryStatus.indexOf(data), 1);
      }
    },
    async updateStatus(campaign) {
      if (!campaign.action) {
        return;
      }

      const newStatus =
        ['ARC', 'ARD'].indexOf(campaign.action) > -1 ? 'ACTIVE' : 'SCHEDULED';
      await PerformanceApi.updateCampaign({ status: newStatus }, campaign.id);
      campaign.status = newStatus;
    },
    async getCampaigns({ status: stausItem, type }) {
      const response = await PerformanceApi.getCampaigns(
        {
          status: stausItem,
          type,
          search: this.search || null,
        },
        this.offset
      );

      const campaignsItems = response.getData([]);
      this.count = campaignsItems.campaign.count;
      const campaigns = this.nullishCoalescing(campaignsItems, 'campaign.rows', []).map((item) => {
        const lastItem = item.reports[item.reports.length - 1];
        let conversionsCount = 0;
        let clicksCount = 0;
        let sendsCount = 0;
        let reachPreview = 0;
        let ordersTotal = 0;

        item.reports.map((a) => {
          conversionsCount += a.conversions;
          clicksCount += a.clicks;
          sendsCount += a.sends;
          ordersTotal += a.orders_total;
        });

        if (lastItem) {
          reachPreview = lastItem.reach_preview;
        }

        const { id, name, configs, status } = item;
        return {
          id,
          name,
          reachPreview,
          sends: sendsCount,
          clicks: clicksCount,
          ordersTotal,
          conversions: conversionsCount,
          action: configs ? configs.type : null,
          status,
          segmentations: this.nullishCoalescing(item, `segmentation_rules`, []),
          message: this.nullishCoalescing(item, 'configs.content.sms.message.text'),
        };
      });

      return campaigns;
    },

    async infinityCampaign($state) {
      const statusQuery = Object.keys(this.queryStatus).map(
        (key) => this.queryStatus[key] && key
      );
      const typeQeury = Object.keys(this.queryType).map(
        (key) => this.queryType[key] && key
      );
      const isQuery = statusQuery.length > 0 || typeQeury.length > 0;
      let campaign = null;

      if (isQuery) {
        campaign = await this.getCampaigns({
          status: Object.keys(this.queryStatus).map(
            (key) => this.queryStatus[key] && key
          ),
          type: Object.keys(this.queryType).map(
            (key) => this.queryType[key] && key
          ),
        });
      } else {
        campaign = await this.getCampaigns({
          status: this.getStatusBySelectedTab(),
        });
      }

      if (campaign.length > 0) {
        if (this.getStatusBySelectedTab() === 'ACTIVE' && !isQuery) {
          this.activeCampaigns.push(...campaign);
          this.offset++;
        } else if (this.getStatusBySelectedTab() === 'FINISHED' && !isQuery) {
          this.completedCampaigns.push(...campaign);
          this.offset++;
        } else {
          this.filteredCampaigns.push(...campaign);
          this.offset++;
        }

        $state.loaded();
      } else {
        $state.complete();
      }
    },
    async handleSearch() {
      if (this.getStatusBySelectedTab() === 'ACTIVE') {
        this.activeCampaigns = await this.getCampaigns({
          search: this.search,
          status: this.getStatusBySelectedTab(),
        });
        this.offset++;
      } else {
        this.completedCampaigns = await this.getCampaigns({
          search: this.search,
          status: this.getStatusBySelectedTab(),
        });
      }
      // eslint-disable-next-line prettier/prettier
      this.loading = false;
    },
    async handleFilter() {
      this.drawer.close = false;
      this.loading = true;
      this.offset = 1;

      this.filtedCampaigns = await this.getCapaigns({
        status: this.queryStatus,
        type: this.queryType,
      });
      this.offset++;
      this.loading = false;
      this.drawer.close = true;
    },
    changeRoute(routeName, params = {}) {
      if (params) {
        return this.$router.push({ name: routeName, params });
      }
      return this.$router.push({ name: routeName });
    },
    getStatusBySelectedTab() {
      return this.selectedTab === 0 ? 'ACTIVE' : 'FINISHED';
    },
  },
  watch: {
    search: Utils.debounce(function () {
      this.isTyping = false;
    }, 1000),
    async isTyping(value) {
      this.loading = true;
      if (!value) {
        this.offset = 1;
        await this.handleSearch();
      }
    },
    async selectedTab(value) {
      this.offset = 1;
      this.loading = true;
      this.completedCampaigns = await this.getCampaigns({
        status: this.getStatusBySelectedTab(),
      });
      this.loading = false;
      this.offset++;
    },
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile,
    }),
  },
};
</script>
<style scoped>
.create-campaign {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 70vh;
}
.create-campaign i {
  color: #8c8c8c99;
  font-size: 70px;
  margin-bottom: 25px;
}
.create-campaign h1 {
  color: var(--label-secondary);
  font-size: 20px;
  line-height: 24px;
  font-family: 'Rubik', sans-serif;
  margin-bottom: 25px;
}
.create-campaign p {
  color: #aaaaabbf;
  font-size: 14px;
  line-height: 17px;
  font-family: 'Rubik', sans-serif;
  margin-bottom: 35px;
}
.btn-create {
  width: 185px;
}
.balance {
  color: #fff;
  margin: auto;
  display: flex;
  align-items: center;
}

.balance .value {
  border: 1px solid #0dc59d73;
  background: #0dc59d14;
  border-radius: 5px;
  padding: 12px 35px;
  line-height: 15px;
  font-size: 12px;
  font-weight: bold;
  color: #0dc59d;
  font-family: 'Lato';
}

.balance .value span {
  font-weight: 900;
  color: #0ed9ad;
}

@media screen and (max-width: 991px) {
  .create-campaign i {
    color: #8c8c8c99;
    font-size: 55px;
    margin-bottom: 20px;
  }
  .create-campaign h1 {
    margin-bottom: 15px;
  }
  .create-campaign p {
    line-height: 20px;
    margin-bottom: 25px;
    text-align: center;
  }
  .balance .value {
    padding: 10px;
  }
}

.tabs ul li {
  display: inline;
  text-align: center;
}
.tabs a {
  cursor: pointer;
  display: inline-block;
  margin-right: 25px;
  margin-bottom: 6px;
  text-decoration: none;
  font-size: 16px;
  line-height: 19px;
  color: #999999ad;
  padding-bottom: 5px;
  border-bottom: 2px solid transparent;
}

.tabs a.active {
  color: var(--default);
  border-color: var(--default);
}

.campaigns {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.occurrences {
  background: var(--box-up);
  padding: 4px 12px;
  margin-left: 10px;
  border-radius: 5px;
  color: #aaaaaae6;
  font-size: 14px;
  line-height: 17px;
  position: relative;
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 991px) {
  .campaigns {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
